import React, {useState, useCallback, useEffect} from 'react';
import Checkbox from "../../../../../components/checkbox";
import _ from "lodash";
import {useList} from "react-use";

import {Collapse} from 'react-collapse';

function PitchingCourse(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const [totalCondition, setTotalCondition] = useState({
        lrIds: selected.lrIds,
        hlIds: selected.hlIds,
        zoneIds: selected.zoneIds
    });
    const [listLr, listLrHelper] = useList ([
        {
            id: 1,
            name: '内角',
            check: false
        },{
            id: 2,
            name: '真ん中',
            check: false
        },{
            id: 3,
            name: '外角',
            check: false
        }
    ]);
    const [listHl, listHlHelper] = useList ([
        {
            id: 1,
            name: '高め',
            check: false
        },{
            id: 2,
            name: '真ん中',
            check: false
        },{
            id: 3,
            name: '低め',
            check: false
        }
    ]);
    const [listZone, listZoneHelper] = useList([
        {
            id: 1,
            name: 'ストライク',
            check: false
        },{
            id: 2,
            name: 'ボール',
            check: false
        }
    ]);

    useEffect(() => {
        if(selected.lrIds.length > 0) {
            selected.lrIds.map(item => {
                const index = listLr.findIndex(i => i.id === item);
                listLr[index].check = true;
            })
        }
        if(selected.hlIds.length > 0) {
            selected.hlIds.map(item => {
                const index = listHl.findIndex(i => i.id === item);
                listHl[index].check = true;
            })
        }
        if(selected.zoneIds.length > 0) {
            selected.zoneIds.map(item => {
                const index = listZone.findIndex(i => i.id === item);
                listZone[index].check = true;
            })
        }

    },[selected])
    useEffect(() => {
        props.onChange(totalCondition)
    }, [totalCondition]);

    const onChangeInOut = useCallback((val, i) => {
        listLrHelper.updateAt(i, { ...listLr[i], check: !listLr[i].check });
        const arr = [...totalCondition.lrIds];
        const index = _.indexOf(arr, val);
        if (index === -1){
            arr.push(val);
        }else {
            arr.splice(index, 1);
        }
        setTotalCondition(state => ({...state, lrIds: arr}));
    },[totalCondition.lrIds]);

    const onChangeHighLow = useCallback((val, i) => {
        listHlHelper.updateAt(i, { ...listHl[i], check: !listHl[i].check });
        const arr = [...totalCondition.hlIds];
        const index = _.indexOf(arr, val);
        if (index === -1){
            arr.push(val);
        }else {
            arr.splice(index, 1);
        }
        setTotalCondition(state => ({...state, hlIds: arr}));
    },[totalCondition.hlIds])

    const onChangeZone = useCallback((val, i) => {
        listZoneHelper.updateAt(i, { ...listZone[i], check: !listZone[i].check });
        const arr = [...totalCondition.zoneIds];
        const index = _.indexOf(arr, val);
        if (index === -1){
            arr.push(val);
        }else {
            arr.splice(index, 1);
        }
        setTotalCondition(state => ({...state, zoneIds: arr}));
    },[totalCondition.zoneIds])

    return (
        <div className='group-filter-item'>
           <div className={'open-collapse'}>
               <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                   <h4>投球コース</h4>
                   <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
               </div>

               <Collapse isOpened={isOpened}>
                   <div style={{ paddingLeft: 5, marginTop: 10}}>
                       <p className="smallTitle">内外角</p>
                       <div style={{display: 'flex'
                       }}>
                           {listLr.map((item, index) => {
                               return (
                                   <div key={item.id} className='search-main-advanced-checkbox'>
                                       <label>
                                           <Checkbox checked={item.check} onClick={() => onChangeInOut(item.id, index)}/>
                                           {item.name}
                                       </label>
                                   </div>
                               )
                           })}
                       </div>
                   </div>
                   <div style={{ paddingLeft: 5}}>
                       <p className="smallTitle">高低</p>
                       <div style={{display: 'flex'
                       }}>
                           {listHl.map((item,index) => {
                               return (
                                   <div key={item.id} className='search-main-advanced-checkbox'>
                                       <label>
                                           <Checkbox checked={item.check} onClick={() => onChangeHighLow(item.id, index)}/>
                                           {item.name}
                                       </label>
                                   </div>
                               )
                           })}
                       </div>
                   </div>
                   <div style={{ paddingLeft: 5}}>
                       <p className="smallTitle">ゾーン</p>
                       <div style={{display: 'flex'
                       }}>
                           {listZone.map((item, index) => {
                               return (
                                   <div key={item.id} className='search-main-advanced-checkbox'>
                                       <label>
                                           <Checkbox checked={item.check} onClick={() => onChangeZone(item.id, index)}/>
                                           {item.name}
                                       </label>
                                   </div>
                               )
                           })}
                       </div>
                   </div>
               </Collapse>

           </div>
            <div className={'close-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>投球コース</h4>
                </div>

                    <div style={{ paddingLeft: 5, marginTop: 10}}>
                        <p className="smallTitle">内外角</p>
                        <div style={{display: 'flex'
                        }}>
                            {listLr.map((item, index) => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onChangeInOut(item.id, index)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div style={{ paddingLeft: 5}}>
                        <p className="smallTitle">高低</p>
                        <div style={{display: 'flex'
                        }}>
                            {listHl.map((item,index) => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onChangeHighLow(item.id, index)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div style={{ paddingLeft: 5}}>
                        <p className="smallTitle">ゾーン</p>
                        <div style={{display: 'flex'
                        }}>
                            {listZone.map((item, index) => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onChangeZone(item.id, index)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

            </div>
        </div>
    )
}

export default PitchingCourse;
